import { useParams, Navigate } from "react-router-dom";

const validLocations = ["srinagar", "baramulla", "jammu"];

function ValidateLocation({ children }) {
  const { location } = useParams();
  if (!validLocations.includes(location)) {
    return <Navigate to="/404" replace />;
  }
  return children;
}

export default ValidateLocation;
